import { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Box, Button, Container, FormControl, FormLabel, Heading, Input,
  Stack, Text, Alert, AlertIcon,
} from '@chakra-ui/react';
import { useRequestPasswordResetMutation } from '../redux/services/auth';

export default function ForgotPasswordPage() {
  const [requestReset, { isLoading }] = useRequestPasswordResetMutation();
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError(null);
    const formData = new FormData(e.currentTarget);
    try {
      await requestReset({ email: formData.get('email') as string }).unwrap();
      setSent(true);
    } catch (err: any) {
      setError(err?.data?.message || 'Failed to send reset email');
    }
  };

  return (
    <Box minH="100vh" display="flex" alignItems="center" justifyContent="center" p={4}>
      <Container maxW="400px">
        <Stack spacing={6}>
          <Box textAlign="center">
            <Heading size="lg" fontFamily="'Poppins', sans-serif" color="brand.700">🎵 MixGenie</Heading>
            <Text color="gray.600" mt={1} fontSize="sm">Reset your password</Text>
          </Box>

          <Box bg="white" p={8} borderRadius="16px" boxShadow="sm" border="1px solid" borderColor="gray.100">
            {sent ? (
              <Alert status="success" borderRadius="10px">
                <AlertIcon />
                Check your email for a password reset link.
              </Alert>
            ) : (
              <form onSubmit={handleSubmit}>
                <Stack spacing={4}>
                  {error && <Alert status="error" borderRadius="10px"><AlertIcon />{error}</Alert>}
                  <FormControl isRequired>
                    <FormLabel fontSize="sm">Email</FormLabel>
                    <Input name="email" type="email" placeholder="you@example.com" borderRadius="10px" />
                  </FormControl>
                  <Button type="submit" isLoading={isLoading} w="full" size="lg">
                    Send reset link
                  </Button>
                </Stack>
              </form>
            )}
            <Text mt={4} fontSize="sm" textAlign="center" color="gray.600">
              <Link to="/login"><Text as="span" color="brand.600">Back to sign in</Text></Link>
            </Text>
          </Box>
        </Stack>
      </Container>
    </Box>
  );
}
